import pushEvent from '@bfe/by-gtm';
import { lazy, Suspense, useEffect, useState } from 'react';

import { useSecuritySettingModal } from '@/store/useSecuritySettingModal/useSecuritySettingModal';
import { useSecuritySettingModalData } from '@/store/useSecuritySettingModal/useSecuritySettingModalData';
const PhoneAuthSetModal = lazy(
  () => import('@/pages/security/comps/phoneAuth/PhoneAuthSetModal'),
);
const GoogleAuthSetModal = lazy(
  () => import('@/pages/security/comps/GoogleAuth/GoogleAuthSetModal'),
);
const FunPasswordSetModal = lazy(
  () => import('@/pages/security/comps/FundPassword/FunPasswordSetModal'),
);

const EmailAuthModal = lazy(
  () => import('@/pages/security/comps/emailAuth/EmailAuthModal'),
);
const AntiPhishingModal = lazy(
  () =>
    import('@/pages/security/comps/AntiPhishingCodeComps/AntiPhishingModal'),
);
const AvatarModal = lazy(
  () => import('@/pages/AccountInfo/components/Avatar/AvatarsModal'),
);

export enum SecuritySettingModalNames {
  AntiPhishingModal = 'AntiPhishingCode',
  Email = 'Email',
  PaymentPassword = 'PaymentPassword',
  Ga = 'Ga',
  Mobile = 'Mobile',
  Kyc = 'Kyc',
  Avatar = 'Avatar',
}

const SecuritySettingModalManager = () => {
  const { showSecuritySettingModalName, closeSecuritySettingModal } =
    useSecuritySettingModal();
  const [loadModalNames, setLoadModalNames] = useState<
    SecuritySettingModalNames[]
  >([]);

  const { antiPhishingCode, hasAntiPhishing } = useSecuritySettingModalData();

  const linkKycLevel = () => {
    pushEvent('click', 'homepage_sidebar_kyc');
    closeSecuritySettingModal();
    window.location.href = `${location.origin}/user/accounts/auth/personal`;
  };

  useEffect(() => {
    if (showSecuritySettingModalName === SecuritySettingModalNames.Kyc) {
      linkKycLevel();
      return;
    }

    if (
      showSecuritySettingModalName !== '' &&
      !loadModalNames.includes(showSecuritySettingModalName)
    ) {
      setLoadModalNames((loadModalNames) => {
        return [...loadModalNames, showSecuritySettingModalName];
      });
    }
  }, [showSecuritySettingModalName]);

  return (
    <Suspense fallback={<></>}>
      {loadModalNames.includes(SecuritySettingModalNames.AntiPhishingModal) && (
        <AntiPhishingModal
          visible={
            showSecuritySettingModalName ===
            SecuritySettingModalNames.AntiPhishingModal
          }
          type={hasAntiPhishing ? 'update' : 'setting'}
          antiPhishingCode={antiPhishingCode}
          closeModal={closeSecuritySettingModal}
        />
      )}
      {loadModalNames.includes(SecuritySettingModalNames.Email) && (
        <EmailAuthModal
          visible={
            showSecuritySettingModalName === SecuritySettingModalNames.Email
          }
        />
      )}
      {loadModalNames.includes(SecuritySettingModalNames.PaymentPassword) && (
        <FunPasswordSetModal
          visible={
            showSecuritySettingModalName ===
            SecuritySettingModalNames.PaymentPassword
          }
        />
      )}
      {loadModalNames.includes(SecuritySettingModalNames.Ga) && (
        <GoogleAuthSetModal
          visible={
            showSecuritySettingModalName === SecuritySettingModalNames.Ga
          }
        />
      )}
      {loadModalNames.includes(SecuritySettingModalNames.Mobile) && (
        <PhoneAuthSetModal
          visible={
            showSecuritySettingModalName === SecuritySettingModalNames.Mobile
          }
        />
      )}
      {loadModalNames.includes(SecuritySettingModalNames.Avatar) && (
        <AvatarModal
          visible={
            showSecuritySettingModalName === SecuritySettingModalNames.Avatar
          }
        />
      )}
    </Suspense>
  );
};

export default SecuritySettingModalManager;
